import ProductPackagesConnector from './productPackages.props';
import ProductPackagesComponent from './productPackages.component';

export default ProductPackagesConnector(ProductPackagesComponent);
